module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["switch-container"],
    style: {
      'width': _vm.width + 'px',
      'height': _vm.height + 'px'
    },
    on: {
      "click": _vm.onchange,
      "swipe": function($event) {
        _vm.onSwipe($event)
      }
    }
  }, [_c('div', {
    staticClass: ["switch-bar"],
    style: {
      'width': _vm.width + 'px',
      'height': _vm.height + 'px'
    }
  }, [_c('div', {
    class: ['container', _vm.isChecked ? 'selected' : 'unselected'],
    style: {
      'width': (_vm.width - 4) + 'px'
    }
  }), _c('image', {
    ref: "switchBar",
    staticClass: ["switch-icon"],
    style: {
      'width': _vm.height + 'px',
      'height': _vm.height + 'px',
      'left': _vm.width - _vm.height + 2 + 'px'
    },
    attrs: {
      "src": _vm.icon,
      "resize": "contain"
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-121d10da!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-switch-bar/index.vue
// module id = 568
// module chunks = 0 1